import { Alert, Divider } from "@mui/material";

import React from "react";
import {
  IN_OFFICE_PATIENT_FOUND,
  IN_OFFICE_PATIENT_NOT_FOUND,
} from "static/constants";
import "./InOfficePatientDetails.css";
import FormSelectField from "components/FormFields/FormSelect";
import useInOfficePatientDetails from "./useInOfficePatientDetails";
import { setInOfficeUploadPatientDetails } from "app/store/manualUpload/slice/manualUploadSlice";

const InOfficePatientDetails = ({
  isExistingPatient,
  hasAccountAccess,
  hasManufacturerAccess,
  updatedAccountName,
  invalidAccountName,
  hasAccessToAccountInNoteFile,
  patientDeviceInformation,
  setUpdatedAccountName,
  inOfficeUploadPatientDetails,
}) => {
  const { dispatch, accountList } = useInOfficePatientDetails();

  return (
    <div className="in-office-patient-details">
      <Alert
        severity={isExistingPatient ? "success" : "warning"}
        className="mt-3 mb-3"
      >
        {isExistingPatient
          ? IN_OFFICE_PATIENT_FOUND
          : IN_OFFICE_PATIENT_NOT_FOUND}
      </Alert>

      {hasAccessToAccountInNoteFile &&
        isExistingPatient &&
        !hasAccountAccess && (
          <Alert severity="error" className="mt-3 mb-3">
            You cannot upload this report since you do not have access to{" "}
            <b>{patientDeviceInformation?.clinic}</b> account.
          </Alert>
        )}

      {isExistingPatient && !hasManufacturerAccess && (
        <Alert severity="error" className="mt-3 mb-3">
          You cannot upload this report since you do not have access to{" "}
          <b>{patientDeviceInformation?.manufacturer}</b> manufacturer.
        </Alert>
      )}

      {!hasAccessToAccountInNoteFile && (
        <Alert severity="error" className="mt-3 mb-3">
          You do not have access to <b>{invalidAccountName}</b>. Select a
          different account below.
        </Alert>
      )}

      <div className="patient-details-section">
        {!patientDeviceInformation?.hasAccessToAccountInNoteFile && (
          <FormSelectField
            margin="none"
            label="Account"
            required={true}
            options={accountList}
            value={updatedAccountName}
            onChange={(value) => {
              const updatedPatientInformation = {
                ...inOfficeUploadPatientDetails,
                inOfficeData: {
                  ...inOfficeUploadPatientDetails.inOfficeData,
                  patientDeviceInformation: {
                    ...patientDeviceInformation,
                    clinic: value,
                  },
                },
              };

              setUpdatedAccountName(value);
              dispatch(
                setInOfficeUploadPatientDetails(updatedPatientInformation)
              );
            }}
          />
        )}

        <Divider className="mt-3 mb-3" />
        <p>
          <span className="patient-detail-title">Encounter Date:</span>
          <span className="patient-detail-value">
            {patientDeviceInformation?.encounterDate &&
            patientDeviceInformation?.encounterDate !== "Invalid date"
              ? patientDeviceInformation?.encounterDate
              : ""}
          </span>
        </p>
        <p>
          <span className="patient-detail-title">First Name:</span>
          <span className="patient-detail-value">
            {patientDeviceInformation?.firstName}
          </span>
        </p>
        <p>
          <span className="patient-detail-title">Last Name:</span>
          <span className="patient-detail-value">
            {patientDeviceInformation?.lastName}
          </span>
        </p>
        <p>
          <span className="patient-detail-title">Date of Birth:</span>
          <span className="patient-detail-value">
            {patientDeviceInformation?.dob}
          </span>
        </p>

        {patientDeviceInformation?.hasAccessToAccountInNoteFile && (
          <p>
            <span class="patient-detail-title">Account:</span>

            <span class="patient-detail-value">
              {patientDeviceInformation?.clinic || "-"}
            </span>
          </p>
        )}
        <p>
          <span className="patient-detail-title">Manufacturer:</span>
          <span className="patient-detail-value">
            {patientDeviceInformation?.manufacturer}
          </span>
        </p>
        <p>
          <span className="patient-detail-title">Device Name :</span>
          <span className="patient-detail-value">
            {patientDeviceInformation?.modelName}
          </span>
        </p>
        <p>
          <span className="patient-detail-title">Device Serial Number:</span>
          <span className="patient-detail-value">
            {patientDeviceInformation?.serialNumber}
          </span>
        </p>
        <p>
          <span className="patient-detail-title">Date of Implant:</span>
          <span className="patient-detail-value">
            {patientDeviceInformation?.doi}
          </span>
        </p>
      </div>
    </div>
  );
};

export default InOfficePatientDetails;
